import Vue from "vue"
import Input from "./m-input"
import Table from "./m-table"
import ClickOutside from 'vue-click-outside'
document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("orderEdit")) {
    return
  }
  window.orderEdit = new Vue({
    el: "#orderEdit",
    components: { minput: Input, "m-table": Table },
    data: {
      id: Number(window.manager.data.id),
      consumer: window.manager.data.consumer,
      documentNumber: window.manager.data.documentNumber,
      dateCreate: window.manager.data.dateCreate,
      dateModify: window.manager.data.dateModify,
      author: window.manager.data.author,
      modifier: window.manager.data.modifier,
      conception: window.manager.data.conception,
      warehouse: window.manager.data.warehouse,
      billNumber: window.manager.data.billNumber,
      outgoingBill: window.manager.data.outgoingBill,
      status: window.manager.data.status,
      deliveryDate: window.manager.data.deliveryDate,
      deliveryTime: window.manager.data.deliveryTime,
      address: window.manager.data.address,
      phone: window.manager.data.phone,
      listUsers: window.manager.data.list.users,
      listOrderStatus: window.manager.data.list.status,
      guid: null,
      street: window.manager.data.street,
      house: window.manager.data.house,
      housing: window.manager.data.housing,
      apartment: window.manager.data.apartment,
      floor: window.manager.data.floor,
      enterance: window.manager.data.enterance,
      paytypes: window.manager.data.paytypes,
      activePanel: "main",
      streetAutoComplete: [],
      dateList: window.manager.data.dateList,
      timeList: window.manager.data.timeList,
      head: window.manager.data.head,
      items: window.manager.data.items,
      canEditDeliveryDate: window.manager.data.canEditDeliveryDate,
      canEditStatus: window.manager.data.canEditStatus,
      isDraft: window.manager.data.isDraft,
      authorID: window.manager.data.authorID,
      addrComment: window.manager.data.addrComment,
      comment: window.manager.data.comment,
      conceptionCode: window.manager.data.conceptionCode,

      outgoingAccountList: window.manager.data.list.outgoingAccount,
      warehouseList: window.manager.data.list.warehouse,
      reckoingList: window.manager.data.list.reckoingAccount,
      conceptionList: window.manager.data.list.conceptions,

      avalPaymentsList: window.manager.data.list.avalPaymentsList,
      defaultPaymentType: window.manager.data.defaultPaymentType,

      search: "",
      searchResult: {},
      formErrors: [],
      updateErrors: [],
      isAjaxCall: false,
      showMesageSuccess: false,
      messageSuccess: "",
      loader: false,
    },
    created() {
      this.deliveryDate = Object.keys(this.dateList)[0]
    },
    directives: { ClickOutside },
    watch: {
      house: function () {
        if (this.street) {
          this.$findStreet();
        }
      },
      street: function (value){
        if (value && this.house){
          this.$findStreet();
        }
      },
      search: function (value) {
        if (value.toString().length > 1) {
          this.isAjaxCall = true
          const url = `${window.location}?itemSerach=${encodeURI(value)}`
          fetch(url, {
            method: "GET",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              this.isAjaxCall = false
              if (data.DATA) {
                this.searchResult = data.DATA
              } else {
                this.searchResult = {}
              }
            })
        } else {
          this.searchResult = {}
        }
      },
    },
    methods: {
      $findStreet(){
        this.formErrors = [];
        this.isAjaxCall = true
        this.guid = null
        const url = `${window.location}?street=${encodeURI(this.street)}&house=${encodeURI(this.house)}`
        fetch(url, {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.isAjaxCall = false
            console.log(data)
            if (data.DATA.GUID && !data.ERRORS) {
              this.guid = data.DATA.GUID
              this.timeList = data.DATA.timeList
              this.dateList = data.DATA.dateList
              this.deliveryDate = Object.keys(this.dateList)[0]

              let firstTime = Object.keys(this.timeList[this.deliveryDate][this.guid])[0]
              this.deliveryTime = this.timeList[this.deliveryDate][this.guid][firstTime]
            } else {
              this.formErrors = data.ERRORS
            }
          })
      },
      $isExistInCart(productID) {
        this.items.forEach((item) => {
          if (item.ID === productID) {
            return true
          }
        })
        return false
      },
      basketAction(action, productID) {
        console.log(action, productID)
        this.updateErrors = []
        if (action === "remove" && !this.$isExistInCart) {
          return false
        }

        const url = `${window.location}?productID=${encodeURI(productID)}&action=${encodeURI(action)}&date=${encodeURI(
          this.deliveryDate
        )}`

        this.isAjaxCall = true
        fetch(url, {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.isAjaxCall = false
            console.log(data)
            if (!data.ERRORS && data.DATA) {
              this.items = data.DATA.items
              this.searchResult[productID]["QTY"] = data.DATA.QTY
            } else {
              this.updateErrors.push(data.ERRORS.join("; "))
            }
          })
      },

      $closeSearch(){
        this.searchResult = [];
        this.search = '';
      },
      autocomplete(value) {
        const url = `/ajax/autocompleteAddress2.php?term=${encodeURI(value)}`
        this.isAjaxCall = true
        fetch(url, {
          method: "GET",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.isAjaxCall = false
            this.streetAutoComplete = []
            data.forEach((item) => {
              this.streetAutoComplete.push(item.value)
            })
          })
      },
      validate() {
        this.formErrors = []
        this.$children.map((child) => {
          if (child.$options.name === "Input") {
            child.validate()
            if (!child.isValid) {
              this.formErrors.push("Поле «" + child.name + "» " + child.internalMessage)
            }
          }
        })
        if (!this.deliveryTime) {
          this.formErrors.push("Не выбрано время доставки.")
        }
        return this.formErrors.length === 0
      },

      saveDraft() {
        let data = {
          DATA: {
            id: this.id,
            consumer: this.consumer,
            documentNumber: this.documentNumber,
            dateCreate: this.dateCreate,
            dateModify: this.dateModify,
            author: this.author,
            modifier: this.modifier,
            conception: this.conception,
            warehouse: this.warehouse,
            billNumber: this.billNumber,
            outgoingBill: this.outgoingBill,
            status: this.status,
            deliveryDate: this.deliveryDate,
            deliveryTime: this.deliveryTime,
            address: this.address,
            phone: this.phone,
            guid: this.guid,
            street: this.street,
            house: this.house,
            housing: this.housing,
            apartment: this.apartment,
            floor: this.floor,
            enterance: this.enterance,
            paytypes: this.paytypes,
            addrComment: this.addrComment,
            comment: this.comment,
          },
          COMMON: {
            ID: this.id,
            IS_DRAFT: this.isDraft,
          },
        }
        this.applyData(data)
      },
      sendOrder() {
        if (!this.validate()) {
          return
        }

        this.loader = true;
        let data = {
          PROPERTIES: {
            1: this.$buildAddress(),
            5: this.enterance,
            6: this.floor,
            7: this.apartment,
            8: this.addrComment,
            10: this.phone,
            13: this.comment,
            18: this.deliveryDate,
            19: this.deliveryTime,
            20: this.house,
            21: this.housing,
            22: this.street,
            23: this.guid,
            38: this.outgoingBill,
            39: this.billNumber,
            40: this.warehouse,
            55: this.conception,
          },
          ORDERDATA: {
            USER_ID: this.consumer,
            CREATED_BY: this.authorID,
            STATUS_ID: this.status,
            PAYMENT_ID: this.defaultPaymentType,
          },
          COMMON: {
            ID: this.id,
            IS_DRAFT: false,
          },
        }

        console.log(data)
        this.applyData(data)
      },

      $buildAddress() {
        let address = ""
        if (this.street) {
          address += this.street
        }

        if (this.house) {
          address += ", д." + this.house
        }

        if (this.housing) {
          address += ", к." + this.housing
        }

        if (this.enterance) {
          address += ", п." + this.enterance
        }

        if (this.floor) {
          address += ", эт." + this.floor
        }

        if (this.apartment) {
          address += ", кв/офис " + this.apartment
        }

        return address
      },
      applyData(data) {
        this.updateErrors = []
        this.isAjaxCall = true
        const url = `${window.location}?save=true`
        fetch(url, {
          method: "POST",
          body: JSON.stringify(data),
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.isAjaxCall = false
            if (data.ERRORS) {
              this.loader = false;
              this.updateErrors = data.ERRORS
              return
            }
            if (data.DATA.URL) {
                window.location.href = data.DATA.URL
            }
          })
      },
      test() {},
    },
  })
})
